// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React, { useContext, useEffect, useState } from 'react';
import { WebSocketContext } from '../../contexts/WebSocketContext';
import MemberContext from '../../contexts/MemberContext';
import { FormattedMessage } from 'react-intl';

import S from './styles';

const ProgressBar = ():JSX.Element => {
  const websocket = useContext(WebSocketContext);
  const member = useContext(MemberContext);
  const [percent, setPercent] = useState(0);
  const [progressCount, setProgressCount] = useState(0);
  const [progressComplete, setProgressComplete] = useState(false);
  const [progressError, setProgressError] = useState(false);

  const handleProcessCount = () => {
    setPercent(0);
    setProgressCount(progressCount => progressCount+1);
  }

  useEffect(() => {
    const isComplete = localStorage.getItem('progressComplete');
    if (isComplete === 'true') {
      setPercent(100);
      setProgressCount(3);
      setProgressComplete(true);
    }
    if (!websocket.websocket) {
      websocket.connectWebsocket()
    }
    if (member.runningChallenge?.status === 'Run') {
      setPercent(100);
      setProgressCount(3);
      setProgressComplete(true);
    }
  }, [])

  useEffect(() => {
    function handleSocket(message: any) {
      // console.log('percent!!', JSON.parse(message.data))
      const data = JSON.parse(message.data);
      if (data.process === 'error') {
        setPercent(0);
        setProgressError(true);
      } else if (data.process === 'Bootstrap_Success') {
        setProgressCount(1);
      } else if (data.process === 'Deploy_Success') {
        setProgressCount(3);
        setPercent(100);
        localStorage.setItem('progressComplete', 'true');
      } else if (data.process !== '') {
        setPercent(data.process);
        if (data.process === 100) {
          handleProcessCount();
        }
      }
      if (data.env) {
        setPercent(100);
        setProgressCount(3);
        setProgressComplete(true);
        localStorage.setItem('progressComplete', 'true');
        localStorage.setItem('progressCount', '3');
      }
    }
    websocket?.websocket?.addEventListener('message', handleSocket);

    return () => {
      websocket?.websocket?.removeEventListener('message', handleSocket);
    }
  }, [websocket])

  return (
    <S.Progress>
      <S.ProgressTitle>
        <S.ProgressPercent>{percent}%</S.ProgressPercent>
        <S.ProgressCount>{progressCount}/3</S.ProgressCount>
      </S.ProgressTitle>
      <S.ProgressInner>
        <S.ProgressBg percent={percent}></S.ProgressBg>
      </S.ProgressInner>
      { progressComplete ? (
        <S.ProgressText><FormattedMessage id="E075" /></S.ProgressText>) : (
        <>
          { progressError ? (
            <S.ProgressText><FormattedMessage id="E076" /></S.ProgressText>
          ) : (
            <S.ProgressText>
              <FormattedMessage id="E074" />
              <S.ProgressAnimate>.</S.ProgressAnimate>
              <S.ProgressAnimate>.</S.ProgressAnimate>
              <S.ProgressAnimate>.</S.ProgressAnimate>
            </S.ProgressText>
          )}
        </>
      )}
    </S.Progress>
  )
}

export default ProgressBar;
